function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "hong-kong-circle-clip"
}, React.createElement("circle", {
  cx: 450,
  cy: 300,
  r: 300
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#hong-kong-circle-clip)",
  fill: "#ee1c25"
}, React.createElement("path", {
  d: "M0 0h900v600H0z"
}), React.createElement("g", {
  id: "hk-a"
}, React.createElement("path", {
  d: "M492.936022 125.19583a27.917245 27.917245 0 0 0-14.901582 41.791893 45.171052 45.171052 0 0 1-20.289932 66.204239 38.650583 38.650583 0 0 0-10.816469 64.313021 68.374981 68.374981 0 0 1-17.067835-93.913589 15.809868 15.809868 0 0 1-1.109109-1.047777 69.880683 69.880683 0 0 0 16.754434 95.793146 90.342104 90.342104 0 0 1 47.430493-173.140933",
  fill: "#fff"
}), React.createElement("path", {
  d: "M451.979333 181.099409l-27.564739 12.021638 29.366483 6.476437-19.951229-22.500734 2.915284 29.930515"
})), React.createElement("g", {
  id: "hk-b"
}, React.createElement("use", {
  href: "#hk-a",
  transform: "rotate(72 450 300)"
}), React.createElement("use", {
  href: "#hk-a",
  transform: "rotate(216 450 300)"
})), React.createElement("use", {
  href: "#hk-b",
  transform: "rotate(72 450 300)"
}));

var SvgHongKong = function SvgHongKong(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "150 0 600 600",
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHongKong, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hong-kong.58570c19.svg";
export { ForwardRef as ReactComponent };